const r = {
  id: "OregonKeno",
  logo: !0,
  name: "Keno",
  style: {
    colorAccent: "#BAEAFF",
    colorPrimary: "#52CBFC",
    highFrequency: {
      backButtonColor: "var(--color-text-primary-primary)",
      ball: {
        background: "radial-gradient(50% 50% at 50% 50%, #BAEAFF 25%, #52CBFC 100%), #163B5C",
        highlight: "0 0 1.75rem 0 #163B5C",
        selected: {
          background: "#163B5C",
          borderColor: "#52CBFC",
          textColor: "var(--color-text-primary-primary-inverted)"
        },
        shadow: "linear-gradient(90deg, rgb(0, 0, 0, 0%) 0%, rgb(0, 0, 0, 40%) 50%, rgb(0, 0, 0, 0%) 100%)",
        textColor: "var(--color-text-primary-primary)"
      },
      bonus: {
        gameCardText: "#163B5C",
        headline: "#163B5C",
        multiplier: "#52CBFC"
      },
      colorPrimaryAccent: "#BAEAFF",
      nextDraw: {
        background: "radial-gradient(124.68% 98.73% at 36.48% 15.75%, rgba(82, 202, 251, 0.10) 0%, rgba(82, 202, 251, 0.70) 100%)",
        backgroundColor: "#BAEAFF",
        cardBorderColor: "#52CBFC",
        notOperating: {
          cardBackground: "linear-gradient(291deg, #163B5C -0.07%, #163B5C 99.97%)",
          numberColor: "var(--color-text-primary-primary-inverted)"
        },
        pending: {
          cardBackground: "linear-gradient(270deg, rgba(22, 59, 92, 0.90) 0.03%, rgba(82, 203, 252, 0.90) 98.59%)",
          numberColor: "var(--color-text-primary-primary-inverted)",
          progressbarColor: "linear-gradient(257deg, rgba(22, 59, 92, 0.72) 7.76%, rgba(22, 59, 92, 0.90) 84.68%)"
        },
        ready: {
          cardBackground: "linear-gradient(291deg, #163B5C -0.07%, #163B5C 99.97%)",
          numberColor: "#BAEAFF"
        },
        textColor: "var(--color-text-primary-primary-inverted)"
      },
      order: {
        background: "linear-gradient(180deg, #D4F2FF 0rem, #52CBFC 21rem, rgba(212, 242, 255, 1))",
        backgroundColor: "#060871",
        topSection: {
          gradient: "radial-gradient(45.73% 50% at 50% 42.67%, #D4F2FF 0%, rgba(212, 242, 255, 0.50) 46.15%, #52CBFC 100%)",
          textColor: {
            primary: "var(--color-text-primary-primary)",
            secondary: "#163B5C"
          }
        }
      },
      results: {
        backgroundColor: "#BAEAFF",
        bottomGradient: "linear-gradient(90deg, rgba(212, 242, 255, 0.8) 0%, rgba(82, 203, 252, 0.8) 100%)",
        bottomText: "#000860"
      },
      teaser: {
        backgroundColor: "#fff",
        backgroundGradient: "radial-gradient(50% 62.76% at 50% 52.02%, rgba(82, 203, 252, 0.00) 0%, rgba(82, 203, 252, 0.60) 60.1%, rgba(82, 203, 252, 0.95) 100%)",
        jackpotColor: "#163B5C",
        logoColor: "#163B5C",
        textColor: "var(--color-text-primary-primary)",
        watch: {
          backgroundGradient: "linear-gradient(180deg, #163B5C 45.24%, #163B5C 99.65%)",
          badge: {
            background: "#163b5c",
            borderColor: "#baeaff",
            gameColor: "#52cbfc",
            textColor: "#ffffff"
          },
          footerColor: "#ffffff",
          gameBackgroundGradient: "radial-gradient(50% 62.76% at 50% 52.02%, rgba(82, 203, 252, 0) 0%, rgba(82, 203, 252, 0.6) 60.1%, rgba(82, 203, 252, 0.95) 100%)",
          icon: {
            arrowsColor: "#252525",
            arrowsColorFade: "#52CBFC",
            pauseColor: "#000860",
            timerColor: "#252525"
          },
          newGameColor: "#163b5c",
          play: {
            colorEnd: "#163b5c",
            colorStart: "#5393CC",
            shadowColor: "#0e2d47"
          },
          titleColor: "#163b5c"
        }
      },
      watchMode: {
        background: "linear-gradient(180deg, #D4F2FF 0%, #52CBFC 34.62%, #52CBFC 68.75%, #52CBFC 90%)",
        badge: {
          background: "#163B5C",
          borderColor: "#BAEAFF",
          gameColor: "#52CBFC",
          textColor: "#fff"
        },
        bonusColor: "#49c2d3",
        bonusEffectColor: "#FFFFFF",
        main: {
          background: "linear-gradient(90deg, #52CBFC 0%, #BAEAFF 50%, #52CBFC 100%)",
          card: {
            background: "#163B5C",
            borderColor: "#BAEAFF"
          }
        },
        textColor: "var(--color-text-primary-primary)"
      }
    }
  }
};
export {
  r as default
};
